const s = {
  name: "PosMedium",
  dimensions: { width: 26, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 26 40" style="enable-background:new 0 0 26 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M8.3,26c0,0.7-0.6,1.2-1.2,1.2S5.8,26.7,5.8,26c0-0.7,0.6-1.2,1.2-1.2S8.3,25.3,8.3,26z"/>
		<path class="st0" d="M11,27.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.3,0.6-1.3,1.2C9.8,26.7,10.3,27.3,11,27.3z"
			/>
		<path class="st0" d="M16.3,26c0,0.7-0.6,1.2-1.3,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C15.7,24.8,16.3,25.3,16.3,26z"
			/>
		<path class="st0" d="M7,31.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2S5.8,29.3,5.8,30C5.8,30.7,6.3,31.3,7,31.3z"/>
		<path class="st0" d="M12.3,30c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.3-0.6-1.3-1.2c0-0.7,0.6-1.2,1.3-1.2C11.7,28.8,12.3,29.3,12.3,30z"
			/>
		<path class="st0" d="M15,31.3c0.7,0,1.3-0.6,1.3-1.2c0-0.7-0.6-1.2-1.3-1.2c-0.7,0-1.2,0.6-1.2,1.2C13.8,30.7,14.3,31.3,15,31.3z"
			/>
		<path class="st0" d="M8.3,34c0,0.7-0.6,1.2-1.2,1.2S5.8,34.7,5.8,34c0-0.7,0.6-1.2,1.2-1.2S8.3,33.3,8.3,34z"/>
		<path class="st0" d="M11,35.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.3,0.6-1.3,1.2C9.8,34.7,10.3,35.3,11,35.3z"
			/>
		<path class="st0" d="M16.3,34c0,0.7-0.6,1.2-1.3,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C15.7,32.8,16.3,33.3,16.3,34z"
			/>
		<path class="st0" d="M3,0C1.3,0,0,1.3,0,3v34c0,1.7,1.3,3,3,3h16c1.7,0,3-1.3,3-3V3c0-1.7-1.3-3-3-3H3z M2,3c0-0.5,0.5-1,1-1h16
			c0.5,0,1,0.5,1,1v17H2V3z M2,22h18v15c0,0.5-0.5,1-1,1H3c-0.5,0-1-0.5-1-1V22z"/>
		<path class="st0" d="M24,2v20h2V2H24z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as PosMedium
};
